import { GraphSelectionModel } from "@features/graph/graphViewModel"

export const graphNodeSelectionStyle = (
  selected: boolean,
  id: string,
  isExcluded: boolean,
): string => {
  if (GraphSelectionModel.parent.has(id)) {
    return "graph-node-container graph-node-background gnc-selected-parent"
  }
  if (GraphSelectionModel.child.has(id)) {
    return "graph-node-container graph-node-background gnc-selected-child"
  }
  return selected
    ? "graph-node-container graph-node-background gnc-selected"
    : isExcluded
    ? "graph-node-container-transparent"
    : "graph-node-container"
}
